<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                is_default: 0,
            }"
            :filters-default="{
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 名前', value: 'name', },
                        { text: '▼ 名前', value: '-name' },
                        { text: '▲ 単価', value: 'price', },
                        { text: '▼ 単価', value: '-price' },
                    ],
                },
            ]"
            filters-q-placeholder="保存名、商品名称、HSコード"
            form-modal-id="shipping_box"
            search-action="shipping_box/index"
            item-id="id"
            @after-save="onAfterSave"
            >
            <template v-slot:form="{ form, init }">
                <ShippingBox :model="form" :init="init"></ShippingBox>
            </template>

            <template v-slot:column="{ item }">
                <b-col md="9" class="align-self-center">
                    <p class="mb-1">
                        <span v-if="item.is_default">
                            ※初期値
                        </span>
                    </p>

                    <p v-if="item.name">
                        {{ item.name }}
                    </p>
                </b-col>
    
                <b-col md="3" class="align-self-center">
                    <b-row>
                        <b-col xs="6" class="align-self-center">
                            縦cm<br>
                            横cm<br>
                            高さcm<br>
                            重量kg<br>
                        </b-col>
                        <b-col xs="6" class="align-self-center text-right">
                            {{ item.depth | BaseNumberFormatter }}<br>
                            {{ item.width | BaseNumberFormatter }}<br>
                            {{ item.height | BaseNumberFormatter }}<br>
                            {{ item.weight | BaseNumberFormatter }}<br>
                        </b-col>
                    </b-row>
                </b-col>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import ShippingBox from '@/components/ShippingBox.vue'

export default {
    components: {
        GridPage,
        ShippingBox,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        onAfterSave() {
            this.$refs.gridPage.search()
        },
    },
}
</script>

